// 格式化通用时间
function formatDate(date, type = 'normal') {
  var now = new Date()
  if (date) {
    now = new Date(date)
  }
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  var date = now.getDate();
  var hour = now.getHours();
  var minute = now.getMinutes();
  var second = now.getSeconds();
  if (month < 10) month = "0" + month;
  if (hour < 10) hour = "0" + hour;
  if (minute < 10) minute = "0" + minute;
  if (second < 10) second = "0" + second;
  if (date < 10) date = "0" + date;
  const dateResult = {
    'normal': year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second,
    'miniCN': year + "年" + month + "月"
  }
  return dateResult[type]
}

// guid生成
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = Math.random() * 16 | 0
    let v = 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

// 判断微信环境
function isWeiXin() {
  let ua = window.navigator.userAgent.toLowerCase()
  if ('wxwork' == ua.match(/wxwork/i)) {
    return true
  }
  return false
}

// 随机字符串
function randomString(len = 16) {
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ+abcdefghijklmnopqrstuvwxyz-012345678*';
  let maxPos = chars.length;
  let pwd = '';
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}


function CheckSocialCreditCode(Code) {
  var patrn = /^[0-9A-Z]+$/;
  //18位校验及大写校验
  if ((Code.length != 18) || (patrn.test(Code) == false)) {
    console.info("不是有效的统一社会信用编码！");
    return false;
  }
  else {
    var Ancode;//统一社会信用代码的每一个值
    var Ancodevalue;//统一社会信用代码每一个值的权重 
    var total = 0;
    var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];//加权因子 
    var str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
    //不用I、O、S、V、Z 
    for (var i = 0; i < Code.length - 1; i++) {
      Ancode = Code.substring(i, i + 1);
      Ancodevalue = str.indexOf(Ancode);
      total = total + Ancodevalue * weightedfactors[i];
      //权重与加权因子相乘之和 
    }
    var logiccheckcode = 31 - total % 31;
    if (logiccheckcode == 31) {
      logiccheckcode = 0;
    }
    var Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
    var Array_Str = Str.split(',');
    logiccheckcode = Array_Str[logiccheckcode];
 
 
    var checkcode = Code.substring(17, 18);
    if (logiccheckcode != checkcode) {
      return false;
    }
    return true;
  }
　}

//小数运算函数
function add(){
  var args = arguments,//获取所有的参数
      lens = args.length,//获取参数的长度
      d = 0,//定义小数位的初始长度，默认为整数，即小数位为0
      sum = 0//定义sum来接收所有数据的和
    //循环所有的参数
  for(var key in args){//遍历所有的参数
      //把数字转为字符串
      var str = ""+args[key];
      if(str.indexOf(".")!=-1){//判断数字是否为小数
          //获取小数位的长度
          var temp = str.split(".")[1].length;
          //比较此数的小数位与原小数位的长度，取小数位较长的存储到d中
          d = d < temp ? temp : d;
      }
  }
  //计算需要乘的数值
  var m = Math.pow(10,d);
  //遍历所有参数并相加
  for(var key in args){
      sum += args[key]*m;
  }
  //返回结果
  return sum/m;

}
function subduction(type, num1, num2) {
 
  var temp1, temp2, a;
  try {
      // 获取temp1小数点后的长度
      temp1 = num1.toString().split(".")[1].length;
  }
  catch (e) {
      temp1 = 0;
  }
  try {
      // 获取temp2小数点后的长度
      temp2 = num2.toString().split(".")[1].length;
  }
  catch (e) {
      temp2 = 0;
  }
  // Math.max(temp1, temp2) 为了获取temp1和temp2两个值中较大的一个
  // Math.pow(a,b) 表示 a 的 b 次方
  a = Math.pow(10, Math.max(temp1, temp2));

  // 计算的方式是先将所有的小数乘为整数，待加减运算执行完之后再除去对应的 a 的值，将其变为小数输出
  // 先判断执行的方式是否是加法，不是的话则执行减法运算
  return type == "add" ? (num1 * a + num2 * a) / a : (num1 * a - num2 * a) / a;
}

function firstToUpperCase (str) {
  return str[0].toUpperCase() + str.slice(1)
}

function firstToLowerCase (str) {
  return str[0].toLowerCase() + str.slice(1)
}

export { formatDate, guid, isWeiXin, randomString, CheckSocialCreditCode, add, subduction, firstToUpperCase, firstToLowerCase }